"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    masteryDetailByClass: {
        title: 'Standards Mastery Detail by Class (%)',
    },
    stackedBarAriaLabel: {
        highlyProficient: '{{percentage}}% of students scored as Highly Proficient',
        proficient: '{{percentage}}% of students scored as Proficient',
        partial: '{{percentage}}% of students scored as Partially Proficient',
        notYet: '{{percentage}}% of students scored as Not Yet Proficient',
    },
};
